/* ===========================================================================
   BB SIZING — "A+" capacity meter
   ---------------------------------------------------------------------------
   Changes the Box Sizing bar in the builder sidebar so that:

     1. The red fill runs across ALL THREE box sizes and only ever GROWS.
        (Before: the fill hit 100% at the Regular threshold, so a shopper with
        a third of the large box still empty was shown a completely full bar.)

     2. A bracket marks where the SHOPPER'S CURRENT box ends. It slides
        outward when their box upgrades, instead of the bar snapping backwards.

     (A "67% full" readout next to the box fee was removed 2026-10-26 at
     Moshe's request; the fillOfBox number is still computed if wanted back.)

   This file is a self-contained override. It adds its own CSS and its own
   markup, and wraps BBPricing.tier + BBShell.render. Nothing in
   box-builder.js or bb-builder-sidebar.liquid is modified, so removing the
   one <script> tag in snippets/bb-assets.liquid fully reverts the change.

   Long term this belongs inside box-builder.js (BBPricing.tier + BBShell.render)
   and bb-builder-sidebar.liquid. It lives here because those two files are
   110KB+ and were not safe to rewrite wholesale.
   =========================================================================== */
(function () {
  "use strict";
  if (window.__bbSizingAPlus) return;
  window.__bbSizingAPlus = true;

  var CSS =
    ".bb-sizing__bar{position:relative;overflow:visible}" +
    ".bb-sizing__bar .bb-sizing__fill{position:absolute;top:0;left:0;bottom:0}" +
    ".bb-sizing__seg{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;" +
      "background:var(--bb-paper,#f8f5eb);opacity:.95;pointer-events:none;z-index:2}" +
    ".bb-sizing__cap{position:absolute;top:-5px;bottom:-5px;width:3px;margin-left:-1.5px;" +
      "border-radius:2px;background:#2b2724;pointer-events:none;z-index:3;" +
      "transition:left .4s cubic-bezier(.4,0,.2,1)}";

  function addCss() {
    if (document.getElementById("bb-sizing-aplus-css")) return;
    var s = document.createElement("style");
    s.id = "bb-sizing-aplus-css";
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function th() {
    var sizing = (window.BBConfig && window.BBConfig.sizing) || {};
    var t = sizing.thresholds || {};
    return {
      small: Number(t.small) || 40,
      regular: Number(t.regular) || 70,
      large: Number(t.large) || 100
    };
  }

  /* Insert the segment dividers and the bracket. */
  function addMarkup() {
    var t = th();
    document.querySelectorAll(".bb-sizing__bar").forEach(function (bar) {
      if (bar.querySelector("[data-bb-sizing-cap]")) return;
      [t.small, t.regular].forEach(function (edge) {
        var pct = (edge / t.large) * 100;
        if (pct <= 0 || pct >= 100) return;
        var d = document.createElement("span");
        d.className = "bb-sizing__seg";
        d.style.left = pct + "%";
        bar.appendChild(d);
      });
      var cap = document.createElement("span");
      cap.className = "bb-sizing__cap";
      cap.setAttribute("data-bb-sizing-cap", "");
      cap.style.left = ((t.small / t.large) * 100) + "%";
      bar.appendChild(cap);
    });
  }

  function paint() {
    var tier;
    try {
      tier = window.BBPricing.summarize();
    } catch (e) {
      return;
    }
    var t = tier.tier || {};
    document.querySelectorAll("[data-bb-sizing-cap]").forEach(function (el) {
      if (typeof t.capPct === "number") el.style.left = t.capPct + "%";
    });
  }

  function patch() {
    if (!window.BBPricing || !window.BBPricing.tier) return false;
    if (!window.BBShell || !window.BBShell.render) return false;

    var origTier = window.BBPricing.tier;
    window.BBPricing.tier = function (sizeUnits, sizing) {
      var out = origTier.call(this, sizeUnits, sizing);
      if (!out) return out;
      var t = th();
      var u = Number(sizeUnits) || 0;
      var boxMax = u <= t.small ? t.small : u <= t.regular ? t.regular : t.large;
      /* Continuous fill across the whole range — never shrinks on upgrade. */
      out.progress = Math.min(100, Math.max(0, (u / t.large) * 100));
      /* Where this shopper's box ends, as a % of the whole track. */
      out.capPct = Math.min(100, Math.max(0, (boxMax / t.large) * 100));
      /* How full THEIR box is (no longer shown). */
      out.fillOfBox = Math.min(100, Math.max(0, (u / boxMax) * 100));
      return out;
    };

    var origRender = window.BBShell.render;
    window.BBShell.render = function () {
      var r = origRender.apply(this, arguments);
      try {
        addMarkup();
        paint();
      } catch (e) {}
      return r;
    };

    addCss();
    addMarkup();
    try {
      window.BBShell.render();
    } catch (e) {}
    return true;
  }

  function boot() {
    addCss();
    if (patch()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (patch() || ++tries > 200) clearInterval(iv);
    }, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();